//@flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import {Divider} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';

type Props = {||};

const useStyles = makeStyles(theme => ({
  dividerVertical: {
    background: colors.grey300,
  },
}));

export default function ActionAppBarDivider(props: Props) {
  const classes = useStyles();

  return (
    <Divider
      flexItem
      orientation="vertical"
      className={classes.dividerVertical}
    />
  );
}

ActionAppBarDivider.propTypes = {};
